<style lang="less" scoped>
@import '../../../style/common/variable';

ul,li {margin: 0;padding: 0;list-style: none;}
.rcep{width: 1200px;display: flex;flex-direction: column;background: #f2f2f2;position: relative;margin: 10px auto;}
.center {width: 1200px;margin: auto;display: flex;justify-content: space-between;}
.navigation {margin-left: 10px !important;}
.txt-list {width: 1200px;}
.txt-list li {display: flex;justify-content: space-around;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;line-height: 40px;padding-left: 15px;background: url(../../../../static/images/zlkindex/dian2.png) 60px 14px no-repeat;}
.txt-list li span {cursor: pointer;}
.txt-list li .tit {width: 70%;text-align: left;}
@media screen and (max-width: @max-screen)
{
  .rcep{width: 96vw; height: 100%; margin: auto;}
  .center{margin: 0;}
  .txt-list{width: 95vw;
    li{justify-content: space-between;
      .tit{overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 75%; text-align: left;}
    }
  }
}
</style>

<template>
  <div class="rcep">
    <Navigation v-if="this.isMobile()" :navigationdatas="navigationListApp" class="navigation"></Navigation>
    <Navigation v-else :navigationdatas="navigationList" class="navigation"></Navigation>
    <div class="center">
      <ul class="txt-list">
        <li v-for="(item, index) in catiddata" :key="index"><span class="tit" @click="goDetails(item)">{{ item.title }}</span><span>{{ item.addtime * 1000 | formatDate() }}</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * Rcep列表页面
 */
import filters from '../method/filter.js'
import Navigation from '../assembly/Navigation.vue'
export default {
  components: {
    Navigation
  },
  mixins: [filters],
  name: '',
  data()
  {
    return {
      navigationList: [
        {theme: '首页', path: '/Kyforum'},
        {theme: 'RCEP业务专栏', path: ''}
      ],
      navigationListApp: [
        {theme: '首页', path: '/KyforumApp'},
        {theme: 'RCEP业务专栏', path: ''}
      ],
      catiddata: [],
      widthCSH: 1200
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.$nextTick(() =>
        {
          this.getData(+nval.query.catid)
        })
      },
      immediate: true
    }
  },
  methods: {
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/RcepDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    getData(catid)
    {
      // 获取对应分类的数据
      let paras = {cmd: 'query', _major: 11, _minor: 107, _exp: `catid=${catid}`, orderby: 'addtime Desc'}
      window.post.getPost(paras).then((ret) =>
      {
        this.catiddata = []
        let temp = []
        ret.forEach(item =>
        {
          temp.push({
            addtime: item.addtime,
            author: item.author,
            catid: item.catid,
            copyfrom: item.copyfrom,
            edittime: item.edittime,
            hits: item.hits,
            id: item.id,
            title: item.title
          })
        })
        this.catiddata = temp
      })
    },
    // 用户设备的判断
    isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/RcepLB.vue